import { createContext } from 'react';
import { PopoverNextContextValue } from './hooks/usePopoverNextContext';

export const PopoverNextContext = createContext<PopoverNextContextValue | null>(
  null,
);
